import { render, staticRenderFns } from "./AddTutorGroup.vue?vue&type=template&id=bc38191c&"
import script from "./AddTutorGroup.vue?vue&type=script&lang=js&"
export * from "./AddTutorGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports